import { CityCeps } from "./cep-models";
import { createContextProvider } from "../components/store-utils";

type CepAction = 
{type: "setCities", cities:CityCeps[]} |
{type: "setSearchTerm", searchTerm:string}

interface CepState {
    searchTerm?: string
    cities?: CityCeps[]
}

function reducer(state:CepState, action:CepAction):CepState {
    switch(action.type){
        case "setSearchTerm": return {...state, searchTerm: action.searchTerm}
        case "setCities": return {...state, cities: action.cities}
        default: return state;
    }
}

export const [CepContext, CepStore] = createContextProvider(reducer, {});
